import React from 'react';
import { formatLastSeen } from '../../utils/formatLastSeen';
import './LearningLiveBar.css';

export default function LearningLiveBar({
  dueCount,
  savedCount,
  reviewedToday,
  dailyGoal,
  updatedAt,
  refreshing,
  onRefresh,
}) {
  return (
    <div className="learning-live-bar" aria-live="polite">
      <div className="learning-live-pills">
        <span className="learning-live-pill learning-live-pill--due">
          Due <strong>{dueCount}</strong>
        </span>
        <span className="learning-live-pill">
          Saved <strong>{savedCount}</strong>
        </span>
        <span className="learning-live-pill">
          Reviewed today <strong>{reviewedToday}</strong>
          {dailyGoal ? ` / ${dailyGoal}` : ''}
        </span>
      </div>
      <div className="learning-live-meta">
        <span className={`learning-live-dot ${refreshing ? 'learning-live-dot--pulse' : ''}`} aria-hidden />
        {updatedAt ? (
          <span className="learning-live-time">Live · {formatLastSeen(updatedAt.toISOString())}</span>
        ) : (
          <span className="learning-live-time">Syncing…</span>
        )}
        {onRefresh && (
          <button type="button" className="learning-live-refresh" onClick={() => onRefresh(false)} disabled={refreshing}>
            Refresh
          </button>
        )}
      </div>
    </div>
  );
}
